import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loading from '../Loading.js';
import ResponsiveTable from '../Table/ResponsiveTable.js';


class SessionTable extends React.Component {

getProposalName(row, record, index, extraData){    
    
    var name = record.Proposal_proposalCode + record.Proposal_proposalNumber;
    return  <Link to={"/sessions/proposal/" + name}><Button style={{ width: '110px'}} bsSize="xsmall" onClick={() => extraData.props.handleSelect(name, record.Proposal_title)}>{name}</Button></Link>;
}

getColumns() {

    return [{
            text: 'id',
            dataField: 'id',
            hidden: true
        },                               
    
        {
            text: 'Proposal',
            width: '70px',
            formatter: this.getProposalName,
            dataField: 'proposal',
            formatExtraData: this,
            hidden: false
        },
       
        {
            text: 'Title',
            dataField: 'Proposal_title'
        }
       
       

    ];
}
/** As we need to search by proposal code and number we would need to add a field composed by code and number */
parseData(data){
    return data.map(proposal => { proposal.proposal = proposal.Proposal_proposalCode + proposal.Proposal_proposalNumber; return proposal;});
}
render() {
        
        if (this.props.proposals.fetching) {
            return <Loading message = 'Loading sessions' /> ;
        }                
        return <div>            
            <ResponsiveTable pageOptions={{sizePerPage:100}} search={true} keyField = 'id'  data = {this.parseData(this.props.proposals.data)}  columns = {this.getColumns()}/>        
        </div>;
    
    }
}

export default SessionTable;


// WEBPACK FOOTER //
// ./src/components/Proposal/ProposalTable.js